import React from 'react';
import { ArrowLeft } from 'lucide-react';
import Footer from '../components/Footer';

const CGV: React.FC = () => {
  return (
    <>
    <div className="min-h-screen bg-stone-50">
      <div className="container-max section-padding py-12">
        <a 
          href="/"
          className="inline-flex items-center space-x-2 text-wood-600 hover:text-wood-700 mb-8"
        >
          <ArrowLeft className="w-4 h-4" />
          <span>Retour à l'accueil</span>
        </a>

        <div className="bg-white rounded-2xl shadow-lg p-8 md:p-12 max-w-4xl">
          <h1 className="text-3xl md:text-4xl font-bold text-stone-900 mb-8">
            Conditions Générales de Vente
          </h1>

          <div className="space-y-8 text-stone-700">
            <section>
              <h2 className="text-2xl font-bold text-stone-900 mb-4">1. Dispositions générales</h2>
              <p className="leading-relaxed">
                Les présentes Conditions Générales de Vente (CGV) s'appliquent à toutes les prestations de services 
                d'agencement et de menuiserie réalisées par ARS AGENCEMENT, artisan menuisier, dont le siège social 
                est situé 90 Rue du Clos Tilhen, 56000 VANNES.
              </p>
              <p className="mt-4 leading-relaxed">
                Toute commande implique l'adhésion sans réserve aux présentes CGV qui prévalent sur tout autre 
                document du client, notamment sur toutes conditions générales d'achat.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-stone-900 mb-4">2. Prestations</h2>
              <p className="leading-relaxed mb-4">
                ARS AGENCEMENT propose les prestations suivantes :
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Agencement intérieur (cuisines, dressings, placards, bibliothèques)</li>
                <li>Agencements extérieurs (terrasses, pergolas, mobilier de jardin)</li>
                <li>Menuiseries extérieures et fermetures (volets, persiennes, portails)</li>
                <li>Sols et parquets</li>
                <li>Isolation, plâtrerie et plafonds</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-stone-900 mb-4">3. Devis et commande</h2>
              <p className="leading-relaxed">
                <strong>3.1 Devis :</strong> Tout devis établi par ARS AGENCEMENT est gratuit et valable 3 mois. 
                Le devis détaille la nature des travaux, les matériaux utilisés, les délais d'exécution et le prix.
              </p>
              <p className="mt-4 leading-relaxed">
                <strong>3.2 Commande :</strong> La commande n'est définitive qu'après signature du devis par le 
                client et versement de l'acompte prévu. La signature du devis vaut acceptation des présentes CGV.
              </p>
              <p className="mt-4 leading-relaxed">
                <strong>3.3 Modification :</strong> Toute modification demandée par le client en cours d'exécution 
                fera l'objet d'un avenant au devis initial.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-stone-900 mb-4">4. Prix et paiement</h2>
              <p className="leading-relaxed">
                <strong>4.1 Prix :</strong> Les prix sont indiqués en euros TTC. Ils comprennent la fourniture des 
                matériaux, la main-d'œuvre, le transport et l'évacuation des déchets sur chantier.
              </p>
              <p className="mt-4 leading-relaxed">
                <strong>4.2 Modalités de paiement :</strong>
              </p>
              <ul className="list-disc pl-6 space-y-2 mt-2">
                <li>Un acompte de 30% à la signature du devis</li>
                <li>40% à la livraison ou en cours de chantier selon avancement</li>
                <li>Solde de 30% à la fin des travaux et après réception sans réserve</li>
              </ul>
              <p className="mt-4 leading-relaxed">
                <strong>4.3 Modes de paiement acceptés :</strong> Espèces (dans les limites légales), chèque, 
                virement bancaire.
              </p>
              <p className="mt-4 leading-relaxed">
                <strong>4.4 Retard de paiement :</strong> En cas de retard de paiement, des pénalités égales à 
                trois fois le taux d'intérêt légal seront appliquées, ainsi qu'une indemnité forfaitaire de 40€ 
                pour frais de recouvrement.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-stone-900 mb-4">5. Délais d'exécution</h2>
              <p className="leading-relaxed">
                Les délais d'exécution sont indiqués dans le devis à titre indicatif. ARS AGENCEMENT s'efforce 
                de respecter ces délais mais ne peut être tenu responsable en cas de retard dû à des circonstances 
                indépendantes de sa volonté (intempéries, retard de livraison des fournisseurs, etc.).
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-stone-900 mb-4">6. Réception des travaux</h2>
              <p className="leading-relaxed">
                À l'issue des travaux, le client procède à la réception. En cas de réserves, celles-ci doivent 
                être formulées par écrit. ARS AGENCEMENT s'engage à y remédier dans les meilleurs délais.
              </p>
              <p className="mt-4 leading-relaxed">
                L'absence de réserves lors de la réception vaut acceptation complète et définitive des travaux.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-stone-900 mb-4">7. Garanties</h2>
              <p className="leading-relaxed">
                <strong>7.1 Garantie légale de conformité :</strong> Conformément aux articles L217-4 et suivants 
                du Code de la consommation.
              </p>
              <p className="mt-4 leading-relaxed">
                <strong>7.2 Garantie des vices cachés :</strong> Conformément aux articles 1641 et suivants du 
                Code civil.
              </p>
              <p className="mt-4 leading-relaxed">
                <strong>7.3 Garantie décennale :</strong> ARS AGENCEMENT est couvert par une assurance décennale 
                pour les travaux concernés par cette garantie.
              </p>
              <p className="mt-4 leading-relaxed">
                <strong>7.4 Garantie de parfait achèvement :</strong> Pendant 1 an à compter de la réception des 
                travaux, ARS AGENCEMENT est tenu de réparer tous les désordres signalés par le client.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-stone-900 mb-4">8. Assurance</h2>
              <p className="leading-relaxed">
                ARS AGENCEMENT dispose d'une assurance responsabilité civile professionnelle et d'une assurance 
                décennale couvrant les travaux réalisés. Les attestations sont disponibles sur demande.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-stone-900 mb-4">9. Obligations du client</h2>
              <p className="leading-relaxed mb-4">
                Le client s'engage à :
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Faciliter l'accès au chantier</li>
                <li>Fournir les branchements électriques et eau nécessaires</li>
                <li>Protéger ou déplacer les biens et meubles présents sur le lieu d'intervention</li>
                <li>Signaler tout problème ou désordre dans les plus brefs délais</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-stone-900 mb-4">10. Résiliation</h2>
              <p className="leading-relaxed">
                <strong>10.1 Droit de rétractation :</strong> Pour les particuliers, un délai de rétractation de 
                14 jours à compter de la signature du devis est accordé, sauf si les travaux ont débuté à la 
                demande expresse du client.
              </p>
              <p className="mt-4 leading-relaxed">
                <strong>10.2 Annulation :</strong> En cas d'annulation après le début des travaux, le client devra 
                indemniser ARS AGENCEMENT des frais engagés et du préjudice subi.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-stone-900 mb-4">11. Responsabilité</h2>
              <p className="leading-relaxed">
                ARS AGENCEMENT ne saurait être tenu responsable des dommages résultant d'une mauvaise utilisation 
                des ouvrages réalisés, d'un défaut d'entretien, ou d'une intervention non autorisée par un tiers.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-stone-900 mb-4">12. Force majeure</h2>
              <p className="leading-relaxed">
                ARS AGENCEMENT ne pourra être tenu responsable de l'inexécution de ses obligations en cas de force 
                majeure telle que définie par la jurisprudence française.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-stone-900 mb-4">13. Propriété intellectuelle</h2>
              <p className="leading-relaxed">
                Les plans, dessins, maquettes et tous documents techniques restent la propriété exclusive d'ARS 
                AGENCEMENT et ne peuvent être reproduits sans autorisation.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-stone-900 mb-4">14. Protection des données personnelles</h2>
              <p className="leading-relaxed">
                Les données personnelles collectées sont traitées conformément à notre Politique de Confidentialité 
                et au RGPD. Pour plus d'informations, consultez notre{' '}
                <a href="/politique-confidentialite" className="text-wood-600 hover:text-wood-700">
                  Politique de Confidentialité
                </a>.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-stone-900 mb-4">15. Médiation</h2>
              <p className="leading-relaxed">
                En cas de litige, le client peut recourir gratuitement au médiateur de la consommation dont relève 
                ARS AGENCEMENT. Les coordonnées du médiateur sont disponibles sur demande.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-stone-900 mb-4">16. Droit applicable et juridiction</h2>
              <p className="leading-relaxed">
                Les présentes CGV sont soumises au droit français. En cas de litige, et après tentative de solution 
                amiable, les tribunaux compétents seront ceux du ressort du siège social d'ARS AGENCEMENT.
              </p>
            </section>
          </div>

          <div className="mt-12 pt-8 border-t border-stone-200">
            <p className="text-sm text-stone-500">
              Date de dernière mise à jour : Octobre 2025
            </p>
          </div>
        </div>
      </div>
    </div>
    <Footer />
    </>
  );
};

export default CGV;
